<shared-modal>
  <!-- header -->
  <h2 slot="header" class="flex">
    Meus disparos
    <span
      class="material-symbols-rounded cursor-pointer ml-auto"
      [routerLink]="['/user', { outlets: { modal: null } }]"
      (click)="analyticsService.logEvent('user_history_close_click')"
    >
      close
    </span>
  </h2>

  <!-- body -->
  <kor-table readonly columns="auto 1fr auto">
    @for (campaign of campaigns; track campaign) {
      <kor-table-row>
        <kor-table-cell>
          <span
            class="material-symbols-rounded block"
            [style.color]="
              sharedService.getCampaignStatusIcon(campaign.status).color
            "
            >{{
              sharedService.getCampaignStatusIcon(campaign.status).icon
            }}</span
          >
        </kor-table-cell>
        <kor-table-cell>
          <b>
            {{ campaign.createdAt.toDate() | date: 'MMM dd H:mm' }}
          </b>
        </kor-table-cell>
        <kor-table-cell>
          <p class="flex items-center gap-3">
            {{ campaign.messagesSent }}/{{ campaign.messagesTotal }}

            <button
              class="tertiary"
              (click)="
                copyCampaign(campaign);
                analyticsService.logEvent('user_history_copy-campaign_click')
              "
            >
              Repetir
            </button>
          </p></kor-table-cell
        >
      </kor-table-row>
    }
  </kor-table>
</shared-modal>
